import { FormEvent, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import CustomPasswordInput from "../../shared/CustomPasswordInput/CustomPasswordInput";
import CustomButton from "../../shared/CustomButton/CustomButton";
import LeopartOnDarkvector from "../../assets/icons/LeopartOnDarkvector";
import { useToastAlert } from "../../hooks/useToastAlert/useToastAlert";
import { RoutesReact } from "../../constants/routes";
import "./ResetPassword.scss";

const AUTH_BASE = (() => {
  const BASE_URL = process.env.REACT_APP_BASE_URL || '';
  return BASE_URL.endsWith('/api')
    ? BASE_URL.replace(/\/api$/, '') + '/api/auth'
    : BASE_URL + '/auth';
})();

export const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const toastAlert = useToastAlert();
  const token = searchParams.get("token") || "";
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleReset = async (e?: FormEvent) => {
    e?.preventDefault();
    if (!token) {
      toastAlert({ duration: 4000, type: "error", message: "Token mancante o non valido" });
      return;
    }
    if (newPassword !== confirmPassword) {
      toastAlert({ duration: 4000, type: "error", message: "Le password non coincidono" });
      return;
    }
    setIsLoading(true);
    try {
      await axios.post(`${AUTH_BASE}/reset-password`, { token, newPassword });
      setDone(true);
      toastAlert({ duration: 4000, type: "success", message: "Password aggiornata con successo" });
      setTimeout(() => navigate(RoutesReact.DIRECTOR_LOGIN), 3000);
    } catch {
      toastAlert({
        duration: 4000,
        type: "error",
        message: "Errore durante il reset. Il link potrebbe essere scaduto.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="reset-page">
      <div className="reset-page__bg" />
      <div className="reset-page__content">
        <div className="reset-page__header">
          <LeopartOnDarkvector w={"40px"} h={"40px"} />
          <span className="reset-page__brand">Leopart</span>
        </div>

        <div className="reset-page__card">
          {done ? (
            <div className="reset-page__done">
              <div className="reset-page__done-icon">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <h2 className="text-bold-24 reset-page__title">Password aggiornata</h2>
              <p className="text-regular-14 reset-page__subtitle">
                La tua password è stata aggiornata con successo. Verrai reindirizzato al login tra pochi secondi.
              </p>
              <Link to={RoutesReact.DIRECTOR_LOGIN} className="reset-page__link">
                Vai al login
              </Link>
            </div>
          ) : (
            <>
              <div className="reset-page__card-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              </div>
              <h2 className="text-bold-24 reset-page__title">Nuova password</h2>
              <p className="text-regular-14 reset-page__subtitle">
                Inserisci la nuova password per il tuo account.
              </p>

              {!token && (
                <div className="reset-page__error-banner">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                  </svg>
                  <span>Link non valido o scaduto. Richiedine uno nuovo dalla pagina di login.</span>
                </div>
              )}

              <form className="reset-page__form" onSubmit={handleReset}>
                <CustomPasswordInput
                  label="Nuova password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <CustomPasswordInput
                  label="Conferma password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <CustomButton
                  fullWidth
                  isLoading={isLoading}
                  type="submit"
                  disabled={!token || !newPassword || !confirmPassword}
                >
                  Aggiorna password
                </CustomButton>
              </form>

              <Link to={RoutesReact.DIRECTOR_LOGIN} className="reset-page__back-link">
                Torna al login
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
